import { render, staticRenderFns } from "./TransferTable.vue?vue&type=template&id=002f2181&scoped=true&"
import script from "./TransferTable.vue?vue&type=script&lang=js&"
export * from "./TransferTable.vue?vue&type=script&lang=js&"
import style0 from "./TransferTable.vue?vue&type=style&index=0&id=002f2181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f2181",
  null
  
)

export default component.exports